// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inspection-detail-view-container {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 50;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }
  
  .inspection-detail-view-container.slide-in {
    transform: translateX(0);
  }
  
  .inspection-detail-view-header {
    position: fixed;
    top: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.6);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px); /* Apply a blur effect */
    width: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 150;
    display: inline-block;
  }
  
  .inspection-detail-view {
    width: 100%;
    height: 100%;
    padding-top: 100px;
    padding-right: 0px;
    padding-left: 0px;
    padding-bottom: 75px;
    background-color: var(--color-grey700);
    overflow-y: auto;
    box-sizing: border-box;
  }
  
  .inspection-detail-view-header-flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  
  .inspection-detail-view-icons-container {
    display: flex;
    align-items: center;
    padding-right: 25px;
    gap: 15px; 
  }
  
  .inspection-detail-view-back-button {
    color: var(--color-grey100);
    z-index: 100;
    padding-left: 25px;
    font-size: 1.1em;
  }

  .inspection-detail-view-back-button:hover {
    color: var(--color-primaryLight);
  }
  
  .inspection-detail-view-spinner {
    color: var(--color-grey100);
    padding-right: 25px;
  }
  
  .inspection-detail-view-icon {
    color: var(--color-grey100);
    margin-left: 15px; 
    width: 75px;
    cursor: pointer;  /* Optional: changes cursor on hover to indicate interactivity */
    font-size: 1.1em;
  }
  
  .inspection-detail-view-header-flex-container {
    display: flex;
    align-items: center; /* Aligns items vertically in the center */
  }
  
  .inspection-detail-view-back-button {
    margin-right: 20px; /* Adds some space between the back button and the spinner */
  }
  
  .inspection-header-info {
    margin-right: 20px; /* Adds some space between the back button and the spinner */
    font-size: 0.9em;
    color: var(--color-grey100);
    font-weight: bold; /* Optional: makes the percentage text bold */
  }
  
  .inspection-detail-view-spinner .loading-container {
    display: flex;
    align-items: center; /* Ensures the text and spinner are vertically aligned */
  }
  
  .loading-status {
    margin-right: 10px; /* Space between the percentage and the spinner */
    font-weight: bold; /* Optional: makes the percentage text bold */
  }
  
  .button-container {
    flex: 1 1; /* Allows the button to take up remaining space */
    padding-left: 15px;
    padding-right: 15px;
    font-size: 0.5em;
  }`, "",{"version":3,"sources":["webpack://./src/components/inspection/InspectionDetailView.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,YAAY;IACZ,8BAA8B;IAC9B,mCAA2B;YAA3B,2BAA2B,EAAE,wBAAwB;IACrD,WAAW;IACX,wCAAwC;IACxC,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,sCAAsC;IACtC,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;IACX,eAAe,GAAG,gEAAgE;IAClF,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB,EAAE,0CAA0C;EACjE;;EAEA;IACE,kBAAkB,EAAE,4DAA4D;EAClF;;EAEA;IACE,kBAAkB,EAAE,4DAA4D;IAChF,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB,EAAE,6CAA6C;EAClE;;EAEA;IACE,aAAa;IACb,mBAAmB,EAAE,wDAAwD;EAC/E;;EAEA;IACE,kBAAkB,EAAE,iDAAiD;IACrE,iBAAiB,EAAE,6CAA6C;EAClE;;EAEA;IACE,SAAO,EAAE,iDAAiD;IAC1D,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB","sourcesContent":[".inspection-detail-view-container {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 50;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .inspection-detail-view-container.slide-in {\n    transform: translateX(0);\n  }\n  \n  .inspection-detail-view-header {\n    position: fixed;\n    top: 50px;\n    height: 50px;\n    background: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(10px); /* Apply a blur effect */\n    width: 100%;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    z-index: 150;\n    display: inline-block;\n  }\n  \n  .inspection-detail-view {\n    width: 100%;\n    height: 100%;\n    padding-top: 100px;\n    padding-right: 0px;\n    padding-left: 0px;\n    padding-bottom: 75px;\n    background-color: var(--color-grey700);\n    overflow-y: auto;\n    box-sizing: border-box;\n  }\n  \n  .inspection-detail-view-header-flex-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .inspection-detail-view-icons-container {\n    display: flex;\n    align-items: center;\n    padding-right: 25px;\n    gap: 15px; \n  }\n  \n  .inspection-detail-view-back-button {\n    color: var(--color-grey100);\n    z-index: 100;\n    padding-left: 25px;\n    font-size: 1.1em;\n  }\n\n  .inspection-detail-view-back-button:hover {\n    color: var(--color-primaryLight);\n  }\n  \n  .inspection-detail-view-spinner {\n    color: var(--color-grey100);\n    padding-right: 25px;\n  }\n  \n  .inspection-detail-view-icon {\n    color: var(--color-grey100);\n    margin-left: 15px; \n    width: 75px;\n    cursor: pointer;  /* Optional: changes cursor on hover to indicate interactivity */\n    font-size: 1.1em;\n  }\n  \n  .inspection-detail-view-header-flex-container {\n    display: flex;\n    align-items: center; /* Aligns items vertically in the center */\n  }\n  \n  .inspection-detail-view-back-button {\n    margin-right: 20px; /* Adds some space between the back button and the spinner */\n  }\n  \n  .inspection-header-info {\n    margin-right: 20px; /* Adds some space between the back button and the spinner */\n    font-size: 0.9em;\n    color: var(--color-grey100);\n    font-weight: bold; /* Optional: makes the percentage text bold */\n  }\n  \n  .inspection-detail-view-spinner .loading-container {\n    display: flex;\n    align-items: center; /* Ensures the text and spinner are vertically aligned */\n  }\n  \n  .loading-status {\n    margin-right: 10px; /* Space between the percentage and the spinner */\n    font-weight: bold; /* Optional: makes the percentage text bold */\n  }\n  \n  .button-container {\n    flex: 1; /* Allows the button to take up remaining space */\n    padding-left: 15px;\n    padding-right: 15px;\n    font-size: 0.5em;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
